import { AthenaEvent } from "@evidenceb/athena-event-storage-schemas";
import { AthenaEventSaveResult } from "../EventStorageClient/AthenaEventSaveResult.js";

export class AthenaEventStreamNotStarted extends Error {
  constructor() {
    super(
      "AthenaEventStream has not yet started. Start it by calling AthenaEventStream.start()",
    );
  }
}

export class ReplicationPushWrongBatchSizeError extends Error {
  constructor(public batchSize: number) {
    super(`Push batch size should always be 1, got ${batchSize}`);
  }
}

export class ReplicationPushRetryableError extends Error {
  constructor(
    public athenaEventSaveResult: AthenaEventSaveResult & { succeeded: false },
  ) {
    super(
      `Replication push failed with retryable error ${athenaEventSaveResult.error.reason}`,
    );
  }
}

export class ReplicationPushNonRetryableError extends Error {
  constructor(
    public athenaEventSaveResult: AthenaEventSaveResult & { succeeded: false },
  ) {
    super(
      `Replication push failed with non-retryable error ${athenaEventSaveResult.error.reason}`,
    );
  }
}

export class ReplicationPullError extends Error {
  constructor(public override cause: Error) {
    super(`Replication pull failed with error: ${cause.message}`);
  }
}

export class SubscriberAlreadyRegistered extends Error {
  constructor(public subscriberId: string) {
    super(`A subscriber with id ${subscriberId} is already registered`);
  }
}

export class SubscriberNotRegistered extends Error {
  constructor(public subscriberId: string) {
    super(`No subscriber registered with id ${subscriberId}`);
  }
}

export class SubscriberProcessAthenaEventError extends Error {
  constructor(
    /** Error that occurred. */
    public error: any,
    /** `AthenaEvent` that was being processed when the error occurred. */
    public athenaEvent: AthenaEvent<any, any>,
    /** Id of the subscriber that was processing the `AthenaEvent`. */
    public subscriberId: string,
  ) {
    super(
      `Subscriber ${subscriberId} failed processing AthenaEvent ${athenaEvent.id}`,
    );
  }
}
